import './step.scss';
import './confirmCharityCardData.scss'

// @vendor
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @components
import { SignaturePattern } from 'components/signaturePattern/signaturePattern';
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

// @actions
import { setWizardButtonStateByButton } from 'actions/okWizard';

// @utils
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;

// @helpers
const { buildNotDeductMessageNGO } = require('utilities/NGOHelper');
const { formatCardNumber } = require('utilities/cardsHelper');
const {
    recordPath,
    PROC_STEP
} = require('utilities/tagging');

// @constants
import { LIMIT_CHARITY_AMOUNT } from 'constants/index';
import {
    messages,
    MULTIPLE_OPERATIONS,
    CHARITY_CARD_HIRE,
    CHARITY_CARD_MODIFY
} from 'constants/operationTypes';

const { CHARITY_CARD_DATA_DETAILS } = messages;

class ConfirmCharityCardData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authorization: true,
            disclaimerErrorState: false,
            showOTP: false
        }
    }

    componentWillMount() {
        const isDeductible = this.props.charityFoundations.toJS().filter(foundation => foundation.suggestion.showNotDeductibleMessage === true);

        this.props.localSetWizardButtonStateByButton('submit', {
            loading: false,
            disabled: isDeductible
        });
    }

    componentDidMount() {
        this.props.onSetAsCurrentStep(this.validate);
        recordPath(window.location.pathname, 'proc-ajustes-ONG', PROC_STEP + '1');
    }

    componentWillReceiveProps(nextProps) {
        const isDeductible = this.props.charityFoundations.toJS().filter(foundation => foundation.suggestion.showNotDeductibleMessage === true);

        if (isDeductible.length !== 0) {
            if (this.state.showOTP) {
                this.disabledButton(nextProps);
            }
        } else {
            this.disabledButton(nextProps);
        }
    }

    disabledButton = (nextProps) => {
        if (nextProps.signaturePass.get('requiredDigits') !== null) {
            if (nextProps.signaturePass.get('requiredDigits').size > 0) {
                this.props.localSetWizardButtonStateByButton('submit', {
                    loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                    disabled: !__CONTACT_CENTER__ && !nextProps.signaturePass.get('isFetchingSignaturePassCodeSuccess')
                });
            } else {
                this.props.localSetWizardButtonStateByButton('submit', {
                    loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                    disabled: !nextProps.signaturePass.get('isFetchingConfigSuccess')
                });
            }
        } else {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                disabled: !nextProps.signaturePass.get('isFetchingConfigSuccess')
            });
        }
        if (nextProps.signaturePass.get('isFetchingSignaturePassCodeSuccess') && nextProps.signaturePass.get('showWarningSMS')) {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                disabled: !nextProps.signaturePass.get('isFetchingConfigSuccess')
            });
        }
    }

    validate = () => {

        const { authorization } = this.state;

        if (authorization) {
            return {
                isValid: true,
                authorization
            };
        }

        this.setState({
            disclaimerErrorState: true
        })

        return {
            isValid: false
        };
    }

    handleOnChange = () => {
        this.setState({
            authorization: !this.state.authorization,
            disclaimerErrorState: false
        });
    }

    handleChangeDeduct = () => {
        const { showOTP } = this.state;

        this.setState({
            showOTP: !showOTP,
        }, () => {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: false,
                disabled: showOTP
            });
        });
    }

    render() {
        const { charityFoundations, minAmount, maxAmount, immCardsById, match: { params: { cardId } } } = this.props;
        const { showOTP } = this.state;
        const messageNGO = buildNotDeductMessageNGO(charityFoundations, false, false, showOTP, this.handleChangeDeduct);
        let showCheckDeduct = messageNGO === true ? true : showOTP;
        const panCard = immCardsById.getIn([cardId, 'number']);
        const beneficiaryName = immCardsById.getIn([cardId, 'beneficiaryNameOnCard']);
        const maxAmountValue = maxAmount === LIMIT_CHARITY_AMOUNT ? formatText('ngoAmounts-maxLimit') : maxAmount;
        const operativeName = formatText('operatives-modifyCharityLimits');
        let cardNumber = formatCardNumber(immCardsById.getIn([cardId, 'number']), 4, '*');

        if (__CONTACT_CENTER__) cardNumber = immCardsById.getIn([cardId, 'number'], '*');

        const operationParams = {
            id: CHARITY_CARD_DATA_DETAILS,
            requestMulti: [{
                serviceCode: CHARITY_CARD_HIRE,
                pan: panCard
            }, {
                serviceCode: CHARITY_CARD_MODIFY,
                pan: panCard
            }]
        }

        return (
            <Fragment>
                <div id="printable-wizard">
                    <FormattedText
                        className="contract-view__wizard__title"
                        value="accountInterveners-securityConfirmation"
                    />
                    <ConfirmationScript operative={operativeName} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    <h4 className="step__subtitle">
                        <FormattedText
                            value="modifySolidarityCard-checkChangesConfirmTitle"
                            className="hire-confirmation__summary-title"
                        />
                    </h4>
                    <div className="row" style={{ marginBottom: '40px' }}>
                        <div className="col-xs-6">
                            <FormattedText
                                value="modifySolidarityCard-cardDataCardNumber"
                                className="hire-confirmation__summary-title"
                            />
                            <div style={{ marginBottom: '10px' }}>{cardNumber}</div>
                            <FormattedText
                                value="hireSolidarityCard-selectedNGOMainBodySummaryMessage"
                                className="hire-confirmation__summary-title"
                            />
                            {
                                charityFoundations.map((charityFoundation, index) =>
                                    <div key={index}>{charityFoundation.getIn(['suggestion', 'name'])}</div>)
                            }
                        </div>
                        <div className="col-xs-6">
                            <FormattedText
                                value="modifySolidarityCard-cardDataHolderNameTitle"
                                className="hire-confirmation__summary-title"
                            />
                            <div style={{ marginBottom: '10px' }}>{beneficiaryName}</div>
                            <div className="hire-confirmation__limit-value">
                                <FormattedText
                                    value="common-minimumLimit"
                                    className="hire-confirmation__summary-title"
                                />:
                                <div>{`${minAmount} €/`}<FormattedText
                                    value="common-month"
                                    format="lowercase"
                                /></div>
                            </div>
                            <div className="hire-confirmation__limit-value">
                                <FormattedText
                                    value="common-maximumLimit"
                                    className="hire-confirmation__summary-title"
                                />:
                                <div>
                                    {maxAmount === LIMIT_CHARITY_AMOUNT ? maxAmountValue : `${maxAmount}€/`}
                                    {maxAmount !== LIMIT_CHARITY_AMOUNT && <FormattedText
                                        value="common-month"
                                        format="lowercase"
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                    {messageNGO}
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    <hr />
                    {showCheckDeduct && <SignaturePattern
                        operationType={MULTIPLE_OPERATIONS}
                        operationParams={operationParams}
                        multiOTPMessageCode={CHARITY_CARD_DATA_DETAILS}
                    />}
                </div>
            </Fragment>
        );
    }
}

ConfirmCharityCardData.propTypes = {
    onSetAsCurrentStep: PropTypes.func.isRequired,
    localOkConsentsActions: PropTypes.func.isRequired,
    charityFoundations: PropTypes.array.isRequired,
    minAmount: PropTypes.number.isRequired,
    maxAmount: PropTypes.number.isRequired,
    match: PropTypes.object.isRequired,
    immCardsById: PropTypes.object.isRequired,
    signaturePass: PropTypes.object,
    localSetWizardButtonStateByButton: PropTypes.func,
    immContracts: PropTypes.object
}

module.exports.ConfirmCharityCardData = connect(
    state => ({
        charityFoundations: state.okWizard.getIn(['steps', 0, 'charityFoundations']),
        immCardsById: state.cards.get('byId'),
        maxAmount: state.okWizard.getIn(['steps', 0, 'maxAmount']),
        minAmount: state.okWizard.getIn(['steps', 0, 'minAmount']),
        signaturePass: state.signaturePattern,
        immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos'])
    }),
    {
        localSetWizardButtonStateByButton: setWizardButtonStateByButton
    }
)(ConfirmCharityCardData);
